import img1b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1b.webp';
import img1c from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1c.webp';
import img1d from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1d.webp';
import img1e from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1e.webp';
import img1f from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1f.webp';
import img1i from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1i.webp';
import img1j from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/1j.webp';

import img2b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/2b.webp';

import img3a from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3a.webp';
import img3b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3b.webp';
import img3c from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3c.webp';
import img3d from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3d.webp';
import img3e from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3e.webp';
import img3f from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3f.webp';
import img3g from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3g.webp';
import img3h from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3h.webp';
import img3i from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3i.webp';
import img3k from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3k.webp';
import img3l from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3l.webp';
import img3n from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3n.webp';
import img3o from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3o.webp';
import img3p from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3p.webp';
import img3q from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3q.webp';
import img3s from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3s.webp';
import img3t from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3t.webp';
import img3u from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3u.webp';
import img3v from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3v.webp';
import img3w from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3w.webp';
import img3x from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/3x.webp';

import img4a from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/4a.webp';
import img4b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/4b.webp';
import img4c from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/4c.webp';
import img4d from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/4d.webp';

import img5b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5b.webp';
import img5d from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5d.webp';
import img5e from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5e.webp';
import img5g from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5g.webp';
import img5i from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5i.webp';
import img5j from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5j.webp';
import img5l from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5l.webp';
import img5m from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/5m.webp';

import img6a from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/6a.webp';
import img6b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/6b.webp';
import img6c from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/6c.webp';

import img7a from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/7a.webp';
import img7b from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/7b.webp';

import img8a from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/8a.webp';
import img8c from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/8c.webp';
import img8d from '../../../images/knbf-skjema/motorbat-ikke-beregnet-for-overnatting/8d.webp';



const motorbatIkkeBeregnetForOvernatting = {
	title: 'Motorbåt ikke beregnet for overnatting',
	logo: 'knbf',
	formDescription: 'Åpen motorbåt, mindre hard-top eller RIB',
	tableQuestions: [
		{header: '1. Er båten tett og fri for vann'},
		{
			text: 'A. På land – skrogets utside',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at skroget ikke har alvorlige skader.</p>
		},{
			text: 'B. På land – bunnplugg, lenseplugg (om dette finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at de(n) sitter fast før sjøsetting. Pluggen kan være slitt eller sprukken. Noen har også en pakning som bør kontrolleres årlig. Byttes ved behov.<img src={img1b}/></p>
		},{
			text: 'C. På land – kontroller at skroggjennomføringer er tette',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger, samt selvlenser.
				<br/>
				<b>På land, utsiden:</b> Skrap bort bunnstoff og begroing rundt gjennomføringen(e), og kontroller at det ikke er tegn på korrosjon, sprekker, rust eller åpninger mellom skroggjennomføringens flens og skroget. Dersom en kuleventil har vært stengt gjennom vinteren, er det en risiko for at den kan ha frosset og sprukket. Ved lynnedslag kan plastgjennomføringer for navigasjonsinstrumenter ha blitt skadet.
				<br/><br/>
				<b>På land, innsiden:</b> Sjekk at skroggjennomføringen sitter fast, ikke har korrosjonsangrep eller viser tegn på lekkasje. Kontroller at slanger ikke har sprekker eller er slitt, og at håndtaket sitter fast og ikke er rustet. Tynne spiralslanger i plast er uegnet for skroggjennomføringer.
				<br/>
				Slanger skal, ifølge gjeldende regelverk, under eller nær vannlinjen være festet til skroggjennomføringen med doble slangeklemmer i rustfritt stål, vendt i hver sin retning. Ventilen bør beveges jevnlig for å unngå at den setter seg fast, og den skal være lett å åpne og lukke.<img src={img1c}/></p>
		},{
			text: 'D. På land – lensepumpe(r)',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at slangene er hele og i god stand, at det ikke finnes sprekker i den manuelle lensepumpens gummimembran, at sugeslangen er utstyrt med sil der den suger i kjølsvinet, og at silen ikke er tett. Kontroller at håndtaket til den manuelle lensepumpen er lett tilgjengelig og passer godt i pumpens håndtak. Sjekk at den elektriske lensepumpen fungerer.<img src={img1d}/></p>
		},{
			text: 'E. På sjøen – selvlensende cockpit (om det finnes)',
			legendIcon: 'y',
			modalContent: <p>Fungerer dreneringen? Er eventuelle slanger ordentlig festet? På båter der selvlensingen munner ut under vannoverflaten, skal det alltid være en stengeventil. Er den lett å åpne, og er den tett når den er stengt?<img src={img1e}/></p>
		},{
			text: 'F. På land – akterdelen på RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller skjøten på akterdelen (der den stive bunnen møter pongtongene) for å sikre at den ikke er løs eller har åpnet seg. Slipp ut litt luft, klem sammen materialet ved skjøtene, og kontroller at du ikke ser snoren eller nettet som holder materialet sammen. Hvis det er synlig, er det en risiko for at hull kan oppstå. I enkelte tilfeller kan dette repareres, ellers må tuben byttes.<img src={img1f}/></p>
		},{
			text: 'G. På land – limingen av tuben mot skroget RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at limingen mellom tubene og skroget ikke viser tegn på å ha sluppet.</p>
		},{
			text: 'H. På land – sprekker i tubene RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke finnes noen sprekker eller skader i materialet/tuben.</p>
		},{
			text: 'I. På land – sveiseforbindelser og sammenføyningssteder RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at tubene, alle sveiseforbindelser og sammenføyningssteder ser intakte ut og ikke lekker. Lekkasje kan lokaliseres ved å duppe en svamp med vann blandet med oppvaskmiddel over tuben. Ved lekkasjestedet vil det dannes luftbobler.<img src={img1i}/></p>
		},{
			text: 'J. På sjøen – kontroller at skroggjennomføringer er tette',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (dvs. kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger samt selvlensere. På sjøen – kontrollere at det ikke finnes noen tegn på lekkasje ved skroggjennomføringen og at det er helt tørt ved gjennomføringens flensmutter, ventilens gjenger og slangetilkoblinger. Ventilen bør beveges med jevne mellomrom for å unngå at den setter seg fast, og den skal være enkel å åpne og lukke.<img src={img1j}/></p>
		},{
			text: 'K. På sjøen – sjekk etter vann i kjølsvinet og i motorrom',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke finnes vann under dørken eller i kjølsvinet. Sørg for at det er rent og tørt i kjølsvinet/motorrommet for raskt å kunne oppdage lekkasjer.</p>
		},{
			text: 'L. På sjøen – kontrollere tubene RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er lekkasje eller skader på tubene.</p>
		},{
			text: 'L. På sjøen – kontrollere tubene RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er lekkasje eller skader på tubene.</p>
		},

		{header: '2. Flytesikkerhet'},
		{
			text: 'A. Finnes det tilstrekkelig og fungerende flytemidler',
			legendIcon: 'y',
			modalContent: <p>Hvis båten skulle kantre eller fylles med vann er det viktig at den fortsatt flyter ved hjelp av flytetankene.</p>
		},{
			text: 'B. Hvis båten har flytetanker',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at de er intakte og sitter ordentlig fast<img src={img2b}/></p>
		},


		{header: '3. Sikkerhetsutstyr'},
		{
			text: 'A. Anker',
			legendIcon: 'y',
			modalContent: <p>Det finnes en rekke ulike typer ankre i forskjellige størrelser og for ulike bunnforhold.
				Tilpass etter båtens størrelse og dybden for ankring. Kontroller tilstanden på tauet/kjettingen, og at sjaklene er godt tilskrudd og sikret. Hvis du har en ankervinsj, gjør det til en vane å feste enden av tauet sikkert i båten.<img src={img3a}/></p>
		},{
			text: 'B. Reserveanker og drivanker',
			legendIcon: 'y',
			modalContent: <p>Anbefales at finnes om bord og er lett tilgjengelig.<img src={img3b}/></p>
		},{
			text: 'C. Badestige/redningsstige',
			legendIcon: 'y',
			modalContent: <p>Minst 560 mm under vannlinjen. Kontroller at du virkelig klarer å få stigen ned i vannet og klarer å klatre opp om du ligger i vannet.<img src={img3c}/></p>
		},{
			text: 'D. Brannteppe',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ligger i etuiet, er helt, og at du vet hvor det befinner seg når du trenger det.<img src={img3d}/></p>
		},{
			text: 'E. Brannslukningsapparat',
			legendIcon: 'y',
			modalContent: <p>Sjekk at manometeret står på grønt, at slangen er hel, plomberingen er intakt, og datoen for siste kontroll eller utløpsdato. Vend den noen ganger, og slå lett på siden for å "lytte" og sikre at pulveret beveger seg fritt i slukkeren. Hvis båten har lithiumbatterier om bord, kreves spesielle brannslukkere. Sjekk kravene fra forsikringsselskapet ditt.<img src={img3e}/></p>
		},{
			text: 'F. Båtshake',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at kroken sitter fast, og om båtshaken er teleskopisk – at den fungerer som den skal.<img src={img3f}/></p>
		},{
			text: 'G. CE-merking/blått skilt',
			legendIcon: 'y',
			modalContent: <p>Angir blant annet maks antall personer båten er godkjent for, maks last og motorstyrke.<img src={img3g}/></p>
		},{
			text: 'H. Fendre',
			legendIcon: 'y',
			modalContent: <p>Minst 4 stk anbefales (tilpasset båtens størrelse).<img src={img3h}/></p>
		},{
			text: 'I. Flytevester eller flyteplagg',
			legendIcon: 'y',
			modalContent: <p>Skal alltid finnes til alle personer om bord, og i noen tilfeller påbudt å bruke. Flytevester skal være CE-merket. Serve/vedlikehold oppblåsbare redningsvester iht. produsentens anbefalinger (PS: årlig ettersyn).<img src={img3i}/></p>
		},{
			text: 'J. Reservefremdrift hvis kun én motor',
			legendIcon: 'y',
			modalContent: <p>Avhengig av båtens størrelse bør det finnes en reservemotor (påhengsmotor), årer eller padleåre om bord. Husk å teste funksjonaliteten.</p>
		},{
			text: 'K. Fortøyningstau',
			legendIcon: 'y',
			modalContent: <p>Minst 4 stk er anbefalt, gjerne i ulike lengder (og tilpasset båtens vekt). Strekkavlastere bør finnes, og husk å kontrollere disse og bytt ved behov.<img src={img3k}/></p>
		},{
			text: 'L. Håndrekke/pulpit/rekkverk',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter ordentlig fast.<img src={img3l}/></p>
		},{
			text: 'M. Bøtte',
			legendIcon: 'y',
			modalContent: <p>Med tau anbefales – og er nyttige å bruke til å øse med, slukke brand eller håndtere andre oppståtte behov og situasjoner.</p>
		},{
			text: 'N. Kasteline/redningsline',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den er hel og i god stand. OBS! En flytende line, slik den skal være, brytes lett ned av sollys og saltvann. Kun den lysbeskyttede delen bør stikke ut av plastposen. Tren på å bruke linen av og til.<img src={img3n}/></p>
		},{
			text: 'O. Pullerter/kryssholt',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter ordentlig fast.<img src={img3o}/></p>
		},{
			text: 'P. Lanterner',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at de fungerer og er rett montert. Må ikke blende båtfører. Ekstra lyskaster/LED-lampe anbefales.<img src={img3p}/></p>
		},{
			text: 'Q. Tauverk for slep og liknende',
			legendIcon: 'y',
			modalContent: <p>Tilpasset båtens størrelse. Kontroller at tauene er lett tilgjengelig og ikke er flokete.<img src={img3q}/></p>
		},{
			text: 'R. Motorromsvifte (for båt med bensindrevet innenbordsmotor)',
			legendIcon: 'y',
			modalContent: <p>Viktig for å ventilere ut bensindamp og redusere eksplosjonsrisiko. Kontroller at den fungerer. Kjøres i minst 2 minutter før start og alltid under fylling av drivstoff.</p>
		},{
			text: 'S. Rekkewire, støtter, pulpit og håndrekker. Rekkewirenett med hensyn til småbarn og kjæledyr.',
			legendIcon: 'y',
			modalContent: <p>Kontroller festene i dekket, at vaierne er hele og uten skader, samt at rekkewire som kan åpnes fungerer som de skal.<img src={img3s}/></p>
		},{
			text: 'T. Reservedunk',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den er hensiktsmessig plassert, festet og fylt med riktig drivstoff.<img src={img3t}/></p>
		},{
			text: 'U. Signalhorn/tute',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den fungerer. Det finnes også håndholdte varianter.<img src={img3u}/></p>
		},{
			text: 'V. Sjøkart',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det gjelder for planlagt farvann, og husk at sjøkart oppdateres og er «ferskvare».<img src={img3v}/></p>
		},{
			text: 'W. Slepefeste/låseøgle',
			legendIcon: 'y',
			modalContent: <p>Kontroller at den sitter fast, er hel og fungerer som den skal.<img src={img3w}/></p>
		},{
			text: 'X. Sikker ombord- og ilandstigning',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det er mulig å gå trygt ombord / i land med tanke på håndtak, sklibeskyttelse, håndrekker og at man ikke kan skade seg på skarpe, utstikkende detaljer på båten. Gode sko reduserer risikoen for å skli.<img src={img3x}/></p>
		},


		{header: '4. Nødutstyr'},
		{
			text: 'A. Førstehjelpsutstyr',
			legendIcon: 'y',
			modalContent: <p>I vanntett pose. Kontroller innholdet og siste forbruksdato.<img src={img4a}/></p>
		},{
			text: 'B. Lyskaster',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at de fungerer, enten den er håndholdt eller fastmontert.<img src={img4b}/></p>
		},{
			text: 'C. Kniv/tau/mykt materiale (for å tette) / plugger i mykt tre',
			legendIcon: 'y',
			modalContent: <p>For reparasjoner osv. Liggeunderlagsmateriale er nyttig for å lage plugger. Det er lett å rive av passende størrelser uten å bruke verktøy. Treplugger i riktig dimensjon kan med fordel festes med tau nær alle gjennomføringer, slik at de alltid er lett tilgjengelige i nødsituasjoner. Lett tilgjengelige kniver på strategiske steder som pulpit/pushpit.<img src={img4c}/></p>
		},{
			text: 'D. Mobiltelefon',
			legendIcon: 'y',
			modalContent: <p>Vanntett beskyttelse og helst med GPS. Husk telefonnr. til Redningsselskapet og sjøens nødnummer: tlf. 02016 eller 120.<img src={img4d}/></p>
		},{
			text: 'E. Reparasjonssett og luftpumpe for RIB',
			legendIcon: 'y',
			modalContent: <p>Reparasjon av alvorligere skader bør overlates til fagfolk. Det finnes tetningssett for midlertidige reparasjoner dersom et hull oppstår i en av tubene. Settet består av to buede plater av galvanisert stål som trekkes sammen med en skrue og vingmutter. Tetningen forhindrer lekkasjer på rifter opptil ca. 9 cm i lengde og hull opptil ca. 6 cm i diameter. Ved liming av reparasjoner skal alltid produsentens instruksjoner følges. Feil liming kan forverre skaden.</p>
		},

		{header: '5. Fremdrift'},
		{
			text: 'A. Eksosrør (for innenbordsmotor)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at vann ikke kan trenge inn bakfra. Eksosrøret skal ha en bue som går opp mot dekket. Den lavere delen av eksoslangen/lyddemperen skal romme det vannet som kan være igjen i systemet når motoren er slått av.<img src={img5b}/></p>
		},{
			text: 'B. Akseltetning',
			legendIcon: 'y',
			modalContent: <p>For innenbordsmotor med rett/strak aksel. Finnes i ulike utførelser og merker. Kontroller tettheten og servicer i henhold til produsentens anbefalinger.</p>
		},{
			text: 'C. Verktøy, samt brytepinne og tennplugger i reserve',
			legendIcon: 'y',
			modalContent: <p>Brytepinne er vanligvis kun nødvendig for mindre utenbordsmotorer.</p>
		},{
			text: 'D. Dødmannsknapp/sikkerhetsbryter',
			legendIcon: 'y',
			modalContent: <p>Hvis en slik finnes, skal den stoppe motoren hvis rormannen faller overbord. Det er viktig at rormannen har den festet, for eksempel rundt armen. Kontroller at den fungerer. En reserve bør være lett tilgjengelig, slik at de som er igjen ombord kan starte motoren hvis føreren har falt over bord.<img src={img5d}/></p>
		},{
			text: 'E. Impeller',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov i henhold til motorprodusentens anbefalinger. Ta med en reserve på lengre turer, for eksempel i mer åpne farvann. Tren på å bytte den før du faktisk trenger å gjøre det (ved innenbordsmotor). Oppbevar reserveimpelleren mørkt i en tett plastpose slik at gummimaterialet ikke tørker ut så raskt.<img src={img5e}/></p>
		},{
			text: 'F. Kjølevann',
			legendIcon: 'y',
			modalContent: <p>Når motoren startes, kontroller alltid at kjølevannet kommer som det skal.</p>
		},{
			text: 'G. Motor',
			legendIcon: 'y',
			modalContent: <p>Serve motoren i henhold til instruksjon fra motorleverandøren.<img src={img5g}/></p>
		},{
			text: 'H. Motorfeste – ved utenbordsmotor',
			legendIcon: 'y',
			modalContent: <p>Kontroller motorfestet på akterspeilet.</p>
		},{
			text: 'H. Motorfeste – ved utenbordsmotor',
			legendIcon: 'y',
			modalContent: <p>Kontroller motorfestet på akterspeilet.</p>
		},{
			text: 'I. Offeranoder',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov. Kan finnes både på motor og aksel, samt på ror og skrog i metall. Kan også være til stede i kjølesystemet på innenbordsmotorer.<img src={img5i}/></p>
		},{
			text: 'J. Sjøvannsfilter (motorkjøling)',
			legendIcon: 'y',
			modalContent: <p>Kontroller og rengjør regelmessig, også i løpet av båtsesongen.<img src={img5j}/></p>
		},{
			text: 'K. Olje',
			legendIcon: 'y',
			modalContent: <p>I motor og drev når det er aktuelt. Skal kontrolleres ofte.</p>
		},{
			text: 'L. Propell, propellaksel',
			legendIcon: 'y',
			modalContent: <p>På land – Kontroller at det ikke er noe glippe og at det ikke finnes sprekker. Kontroller at bolten som propellen er festet med, er sikret, og at bladene på foldpropellen er ordentlig festet.<img src={img5l}/></p>
		},{
			text: 'M. Årer',
			legendIcon: 'y',
			modalContent: <p>Hvis årer finnes ombord, kontroller at de er hele og at åregaflene sitter fast.<img src={img5m}/></p>
		},

		{header: '6. Styresystem'},
		{
			text: 'A. Hydraulikkstying',
			legendIcon: 'y',
			modalContent: <p>Kontroller funksjon og oljenivå. En ekstra flaske med hydraulolje er alltid bra å ha med. Undersøk om du kan ordne en reserve-styring hvis det skulle oppstå feil med det ordinære systemet.<img src={img6a}/></p>
		},{
			text: 'B. Kompass – fastmontert',
			legendIcon: 'y',
			modalContent: <p>Kontroller når båten ligger stille at kompasset ikke blir forstyrret når rattet vris eller av elektronisk utstyr. Vær spesielt oppmerksom på eventuelle motorer til vindusviskere.<img src={img6b}/></p>
		},{
			text: 'C. Styre- og girwire som passerer gjennom motorrommet',
			legendIcon: 'y',
			modalContent: <p>Kontroller at gjennomføringene er rimelig vanntette.<img src={img6c}/></p>
		},{
			text: 'D. Styring med wire',
			legendIcon: 'y',
			modalContent: <p>Kontrollere at vaierne er i god stand og at de ikke går i for bratte bøyninger.</p>
		},

		{header: '7. Elektrisk anlegg'},
		{
			text: 'A. Batterier',
			legendIcon: 'y',
			modalContent: <p>Plassering skal være adskilt fra drivstofftank og godt festet, samt plassert slik at de ikke blir oversvømt av moderate mengder vann som trenger inn. Ingen løse gjenstander som kan kortslutte polene skal være i samme rom. Sjekk eventuell oksid på polene. Rens og smør inn.
				<br/><br/>
				Det bør alltid være en tilgjengelig hovedbryter slik at batteriene kan kobles fra i tilfelle elektrisk feil. Hvis båten har litiumbatterier, er det viktig å sette seg godt inn i aktuell type og følge produsentens anbefalinger. Litiumbatterier har mange fordeler, men vedlikehold, oppbevaring, lading, samt ved skader eller brann, skiller de seg fra blybatterier. Spesiell lader og et BMS (Battery Management System) kreves, samt at generator/motor er tilpasset. Hvis batterisystemet byttes fra blybatterier til litium, bør arbeidet utføres på en fagmessig måte med relevante regelverk og gjeldende standarder. Feil håndtering eller installasjon kan skade batteriene. Ladere beregnet for litiumbatterier skal benyttes.<img src={img7a}/></p>
		},
		{
			text: 'B. Elkabler',
			legendIcon: 'y',
			modalContent: <p>Skal være i flerkjerneutførelse og dimensjonert i henhold til gjeldende regler for elektrisk installasjon i båt.<img src={img7b}/></p>
		},{
			text: 'C. Reservesikringer',
			legendIcon: 'y',
		},

		{header: '8. Drivstoffanlegg'},
		{
			text: 'A. Drivstoffilter',
			legendIcon: 'y',
			modalContent: <p>Bytt drivstoffilter før hver sesong. Ved oppdagelse av begroing, rengjør tanken. Det er lurt å ha et ekstra filter med som reserve, eller et dobbelt drivstoffilter som kan omkobles.<img src={img8a}/></p>
		},{
			text: 'B. Drivstoffslanger',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de er av godkjent kvalitet og i god stand, trukket med gummi-gjennomføringer for å unngå slitasjeskader.</p>
		},{
			text: 'C. Drivstofftank',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong tanktilkoblinger, pakninger og bytt ved behov, samt rengjør tanken ved behov.<img src={img8c}/></p>
		},{
			text: 'D. Vannutskiller (om det finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er lekkasje ved filteret og dets tilkoblinger, samt at de er byttet i henhold til instruksjonene. Tøm eventuelt vann.<img src={img8d}/></p>
		},
	]
}

export default motorbatIkkeBeregnetForOvernatting
